module.exports = __webpack_public_path__ + "static/media/xbp.d3b5a2a4.svg";